
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class PatientVisit extends Vue {

  headerTranslations: Record<string, string> = {
    PatientIdentifier: "Kennung des Patienten",
    Gender: "Geschlecht",
    FirstVisitDate: "Datum des ersten Besuchs",
    LastVisitDate: "Datum des letzten Besuchs",
    VisitDuration: "Dauer des Besuchs",
    CurrentAge: "Aktuelles Alter",
    FirstDiagnoseDate: "Datum der Erstdiagnose",
    AgeAtFirstDiagnosis: "Alter bei Erstdiagnose",
    PatientCount: "Anzahl der Patienten",
    PatientPercentage: "Prozentsatz der Patienten"
  };


  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("patientVisit");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("patientVisit");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
